export const getInvolved = {
  hero: {
    badge: "Fanya Tofauti",
    title: "Jiunge Nasi Kubadilisha Maisha",
    subtitle: "Kila mchango, iwe ni wakati au rasilimali, inatusaidia kuleta tumaini na heshima kwa wakimbizi na jamii zilizo hatarini nchini Uganda."
  },
  donation: {
    title: "Toa Mchango",
    subtitle: "Msaada wako wa kifedha una athari moja kwa moja kwa maisha. Chagua jinsi unavyotaka kuchangia.",
    oneTime: "Mara Moja",
    recurring: "Kila Mwezi",
    amounts: {
      custom: "Kiasi Maalum"
    },
    button: "Toa Mchango Sasa",
    secure: "Malipo salama yanayoendeshwa na Stripe"
  },
  volunteer: {
    title: "Kuwa Mtoaji Msaada",
    subtitle: "Jiunge na timu yetu ya wajitoleaji wanaojitolea wanaofanya tofauti halisi ardhini.",
    form: {
      fullName: "Jina Kamili",
      fullNamePlaceholder: "Weka jina lako kamili",
      email: "Anwani ya Barua Pepe",
      emailPlaceholder: "barua.pepe@mfano.com",
      phone: "Nambari ya Simu",
      phonePlaceholder: "+256 XXX XXX XXX",
      location: "Mahali Ulipo",
      locationPlaceholder: "Jiji, Nchi",
      skills: "Ujuzi na Utaalamu",
      skillsPlaceholder: "mfano: Matibabu, Ufundishaji, Ujenzi, Utawala...",
      availability: "Upatikanaji",
      availabilityPlaceholder: "mfano: Wikendi, Wakati wote, Wiki 2 kwa mwezi...",
      motivation: "Kwa nini unataka kuwa mtoaji msaada?",
      motivationPlaceholder: "Tuambie ni nini kinachokuchochea kujiunge na dhamira yetu...",
      submit: "Wasilisha Maombi",
      submitting: "Inatuma...",
      successMessage: "Asante! Tutawasiliana nawe hivi karibuni.",
      errorMessage: "Kuna hitilafu. Tafadhali jaribu tena."
    }
  },
  campaigns: {
    title: "Kampeni za Ukusanyaji Fedha Zinazoendelea",
    subtitle: "Unga mkono mipango maalum inayofanya athari ya haraka.",
    raised: "imekusanywa",
    goal: "lengo",
    donors: "wachangiaji",
    daysLeft: "siku zilizobaki",
    share: "Shiriki Kampeni"
  },
  partnership: {
    title: "Shirikiana Nasi",
    subtitle: "Mashirika na biashara zinaweza kuongeza athari yetu kupitia ushirikiano wa kimkakati.",
    form: {
      orgName: "Jina la Shirika",
      orgNamePlaceholder: "Jina la shirika lako",
      contactName: "Mtu wa Mawasiliano",
      contactNamePlaceholder: "Jina kamili",
      email: "Anwani ya Barua Pepe",
      emailPlaceholder: "mawasiliano@shirika.com",
      phone: "Nambari ya Simu",
      phonePlaceholder: "+XXX XXX XXX XXX",
      partnershipType: "Aina ya Ushirikiano",
      partnershipTypePlaceholder: "mfano: Ufadhili wa Kampuni, Mchango wa Vitu, Programu ya Kujitolea...",
      message: "Tuambie kuhusu maslahi yako",
      messagePlaceholder: "Eleza jinsi unavyotaka kushirikiana nasi na rasilimali unazoweza kutoa...",
      submit: "Tuma Hoja",
      submitting: "Inatuma...",
      successMessage: "Asante! Tutawasiliana nawe hivi karibuni.",
      errorMessage: "Imeshindwa kutuma. Tafadhali jaribu tena."
    }
  }
};
